export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;

export const ACCEPTED_ATTACHMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".jpg",
  ".jpeg",
  ".gif",
  ".tif",
  ".txt",
  ".xml",
  ".html",
];
